/* Oz BBQ — product page (AAA). Vanilla, no dependencies.
   Gallery, variant picker, quantity, ajax add-to-cart with confirmation,
   sticky sub-nav / buy bar, description clamp, rails. */
(function () {
  'use strict';
  var root = document.querySelector('[data-aaa-pdp]');
  if (!root) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var smooth = reduceMotion ? 'auto' : 'smooth';
  var dataEl = root.querySelector('[data-aaa-pdp-data]');
  var data = {};
  try { data = JSON.parse(dataEl.textContent); } catch (e) { data = { variants: [] }; }
  var variants = data.variants || [];

  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }

  /* ---- Money ---------------------------------------------------------- */
  function formatMoney(cents, format) {
    format = format || data.moneyFormat || '${{amount}}';
    cents = parseInt(cents, 10) || 0;
    function withDelims(n, prec, thou, dec) {
      var parts = (n / 100).toFixed(prec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(dec);
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(cents, 0, '.', ',');
        default: return withDelims(cents, 2, ',', '.');
      }
    });
  }
  function moneyTrim(cents) { return formatMoney(cents).replace(/\.00(?!\d)/, ''); }

  /* ---- Gallery -------------------------------------------------------- */
  var gal = $('[data-aaa-gal]');
  var track = gal && $('[data-aaa-gal-track]', gal);
  var slides = track ? $$('[data-aaa-gal-slide]', track) : [];
  var thumbs = gal ? $$('[data-aaa-gal-thumb]', gal) : [];
  var current = 0;

  function goTo(i, behavior) {
    if (!track || !slides.length) return;
    i = Math.max(0, Math.min(slides.length - 1, i));
    track.scrollTo({ left: slides[i].offsetLeft, behavior: behavior || smooth });
  }
  function setActive(i) {
    if (i === current && gal.dataset.ready) return;
    current = i;
    gal.dataset.ready = '1';
    thumbs.forEach(function (t, n) {
      var on = n === i;
      t.classList.toggle('is-active', on);
      if (on) { t.setAttribute('aria-current', 'true'); } else { t.removeAttribute('aria-current'); }
    });
    var active = thumbs[i];
    if (active && active.parentElement) {
      var p = active.parentElement;
      var vertical = p.scrollHeight > p.clientHeight + 4;
      if (vertical) {
        var top = active.offsetTop - p.clientHeight / 2 + active.offsetHeight / 2;
        p.scrollTo({ top: top, behavior: smooth });
      } else {
        var left = active.offsetLeft - p.clientWidth / 2 + active.offsetWidth / 2;
        p.scrollTo({ left: left, behavior: smooth });
      }
    }
    var idx = $('[data-aaa-gal-index]', gal);
    if (idx) idx.textContent = i + 1;
    var bar = $('[data-aaa-gal-bar]', gal);
    if (bar) bar.style.transform = 'translateX(' + (i * 100) + '%)';
    var prev = $('[data-aaa-gal-prev]', gal), next = $('[data-aaa-gal-next]', gal);
    if (prev) prev.disabled = i === 0;
    if (next) next.disabled = i === slides.length - 1;
    gal.classList.toggle('is-video', !!slides[i].querySelector('[data-aaa-gal-video]'));
    // Stop a playing video when it's swiped away.
    slides.forEach(function (s, n) {
      if (n !== i) {
        var v = s.querySelector('[data-aaa-gal-video].is-playing');
        if (v) resetVideo(v);
      }
    });
  }
  function resetVideo(v) {
    var frame = v.querySelector('iframe, video');
    if (frame) frame.remove();
    v.classList.remove('is-playing');
    var poster = v.querySelector('.aaa-pdp-gal__poster'), btn = v.querySelector('[data-aaa-gal-play]');
    if (poster) poster.hidden = false;
    if (btn) btn.hidden = false;
  }
  if (track) {
    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        setActive(Math.max(0, Math.min(slides.length - 1, i)));
      });
    }, { passive: true });
    var thumbWrap = $('[data-aaa-gal-thumbs]', gal);
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        // The "+N" tile opens the full set as well as showing its own image.
        if (thumbWrap && !thumbWrap.classList.contains('is-all')) {
          var desk = window.matchMedia('(min-width: 990px)').matches;
          if (t.hasAttribute(desk ? 'data-more-d' : 'data-more-m')) thumbWrap.classList.add('is-all');
        }
        goTo(parseInt(t.getAttribute('data-aaa-gal-thumb'), 10));
      });
    });
    var pb = $('[data-aaa-gal-prev]', gal), nb = $('[data-aaa-gal-next]', gal);
    if (pb) pb.addEventListener('click', function () { goTo(current - 1); });
    if (nb) nb.addEventListener('click', function () { goTo(current + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
    });
    // Desktop click-and-drag to flip, like a swipe on a phone. Touch and
    // trackpads already scroll the track natively; a mouse drag did nothing,
    // so a shopper trying to flip that way read the gallery as broken
    // (Cart Spy, Oct 2026). Snap is suspended mid-drag so the track follows
    // the pointer, then it settles on the slide the drag pointed to. A real
    // drag swallows the click that follows, so it never opens the lightbox.
    var drag = null, dragMoved = false;
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0 || slides.length < 2) return;
      drag = { x: e.clientX, left: track.scrollLeft, from: current };
      dragMoved = false;
    });
    window.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      if (!dragMoved && Math.abs(dx) < 6) return;
      if (!dragMoved) {
        dragMoved = true;
        track.style.scrollSnapType = 'none';
        track.style.scrollBehavior = 'auto';
        gal.classList.add('is-dragging');
      }
      track.scrollLeft = drag.left - dx;
    });
    window.addEventListener('pointerup', function (e) {
      if (!drag) return;
      var d = drag; drag = null;
      if (!dragMoved) return;
      var dx = e.clientX - d.x;
      var step = Math.abs(dx) > track.clientWidth * 0.12 ? (dx < 0 ? 1 : -1) : 0;
      track.style.scrollSnapType = '';
      track.style.scrollBehavior = '';
      gal.classList.remove('is-dragging');
      goTo(d.from + step);
    });
    track.addEventListener('click', function (e) {
      if (dragMoved) { e.preventDefault(); e.stopPropagation(); dragMoved = false; }
    }, true);
    $$('[data-aaa-gal-play]', gal).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = btn.closest('[data-aaa-gal-video]');
        var tpl = v.querySelector('template');
        if (!tpl) return;
        v.appendChild(tpl.content.cloneNode(true));
        v.classList.add('is-playing');
        btn.hidden = true;
        var poster = v.querySelector('.aaa-pdp-gal__poster');
        if (poster) poster.hidden = true;
      });
    });
    setActive(0);
    var start = $('[data-aaa-gal-start]', gal);
    if (start) showMedia(start.getAttribute('data-aaa-gal-start'), 'auto');
  }
  function showMedia(mediaId, behavior) {
    if (!mediaId || !slides.length) return;
    for (var i = 0; i < slides.length; i++) {
      if (String(slides[i].getAttribute('data-media-id')) === String(mediaId)) { goTo(i, behavior); return; }
    }
  }

  /* ---- Lightbox -------------------------------------------------------- */
  var lb = $('[data-aaa-lb]');
  // Overlays live on <body> so no section stacking context can sit above them.
  if (lb) document.body.appendChild(lb);
  var addedEl = $('[data-aaa-added]');
  if (addedEl) document.body.appendChild(addedEl);
  var zooms = gal ? $$('.aaa-pdp-gal__zoom', gal) : [];
  if (lb && zooms.length) {
    var lbImg = $('[data-aaa-lb-img]', lb);
    var lbCount = $('[data-aaa-lb-count]', lb);
    var lbPrev = $('[data-aaa-lb-prev]', lb), lbNext = $('[data-aaa-lb-next]', lb);
    var lbIndex = 0, lbReturn = null;
    function lbShow(i) {
      lbIndex = Math.max(0, Math.min(zooms.length - 1, i));
      lb.classList.remove('is-zoomed');
      var a = zooms[lbIndex];
      var inner = a.querySelector('img');
      lbImg.src = a.getAttribute('href');
      lbImg.alt = inner ? inner.alt : '';
      lbCount.textContent = (lbIndex + 1) + ' / ' + zooms.length;
      lbPrev.disabled = lbIndex === 0;
      lbNext.disabled = lbIndex === zooms.length - 1;
    }
    function lbOpen(i) {
      lbReturn = document.activeElement;
      lbShow(i);
      lb.hidden = false;
      document.documentElement.classList.add('aaa-no-scroll');
      $('[data-aaa-lb-close]', lb).focus();
    }
    function lbClose() {
      lb.hidden = true;
      document.documentElement.classList.remove('aaa-no-scroll');
      // Bring the gallery to the photo they were last looking at.
      var slide = zooms[lbIndex].closest('[data-aaa-gal-slide]');
      var si = slides.indexOf(slide);
      if (si > -1) goTo(si, 'auto');
      if (lbReturn) { try { lbReturn.focus({ preventScroll: true }); } catch (e) { /* noop */ } }
    }
    zooms.forEach(function (a, i) {
      a.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); lbOpen(i); });
    });
    $('[data-aaa-lb-close]', lb).addEventListener('click', lbClose);
    lbPrev.addEventListener('click', function () { lbShow(lbIndex - 1); });
    lbNext.addEventListener('click', function () { lbShow(lbIndex + 1); });
    lbImg.addEventListener('click', function (e) {
      var r = lbImg.getBoundingClientRect();
      lbImg.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      lb.classList.toggle('is-zoomed');
    });
    lbImg.addEventListener('mousemove', function (e) {
      if (!lb.classList.contains('is-zoomed')) return;
      // Pan against the stage (a stable box), not the scaled image.
      var r = $('[data-aaa-lb-stage]', lb).getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width * 100, y = (e.clientY - r.top) / r.height * 100;
      lbImg.style.transformOrigin = Math.max(0, Math.min(100, x)) + '% ' + Math.max(0, Math.min(100, y)) + '%';
    });
    var tx = null;
    lb.addEventListener('touchstart', function (e) { tx = e.touches.length === 1 ? e.touches[0].clientX : null; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (tx === null || lb.classList.contains('is-zoomed')) return;
      var dx = e.changedTouches[0].clientX - tx;
      if (Math.abs(dx) > 50) lbShow(lbIndex + (dx < 0 ? 1 : -1));
      tx = null;
    }, { passive: true });
    lb.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); lbClose(); }
      else if (e.key === 'ArrowRight') { lbShow(lbIndex + 1); }
      else if (e.key === 'ArrowLeft') { lbShow(lbIndex - 1); }
      else if (e.key === 'Tab') {
        var f = $$('button:not([disabled])', lb);
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  /* ---- Variant picker -------------------------------------------------- */
  var form = $('.aaa-pdp__form');
  var idInput = $('[data-aaa-variant-input]');
  var optSets = $$('[data-aaa-opt]');

  function selectedOptions() {
    return optSets.map(function (fs) {
      var c = fs.querySelector('input:checked');
      return c ? c.value : null;
    });
  }
  function findVariant(opts) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { ok = false; break; } }
      if (ok) return v;
    }
    return null;
  }
  function currentVariant() {
    var id = idInput ? String(idInput.value) : '';
    for (var i = 0; i < variants.length; i++) { if (String(variants[i].id) === id) return variants[i]; }
    return variants[0] || null;
  }
  function labelFor(v) {
    if (!v) return 'Unavailable';
    if (v.backorder) return 'Pre-order';
    return v.available ? 'Add to cart' : 'Sold out';
  }
  function markAvailability() {
    var sel = selectedOptions();
    optSets.forEach(function (fs, oi) {
      $$('input', fs).forEach(function (inp) {
        var trial = sel.slice(); trial[oi] = inp.value;
        var v = findVariant(trial);
        var lab = fs.querySelector('label[for="' + inp.id + '"]');
        if (lab) lab.classList.toggle('is-unavailable', !v || !(v.available || v.backorder));
      });
    });
  }
  function applyVariant(v, fromUser) {
    var atcLabels = $$('[data-aaa-atc-label]');
    var atcBtns = [$('[data-aaa-atc]')].concat($$('[data-aaa-proxy-atc]')).filter(Boolean);
    if (!v) {
      atcLabels.forEach(function (l) { l.textContent = 'Unavailable'; });
      atcBtns.forEach(function (b) { b.disabled = true; });
      return;
    }
    if (idInput) { idInput.value = v.id; idInput.setAttribute('value', v.id); }
    var can = v.available || v.backorder;
    atcLabels.forEach(function (l) { l.textContent = labelFor(v); });
    atcBtns.forEach(function (b) { b.disabled = !can; });
    $$('[data-aaa-price], [data-aaa-price-mini]').forEach(function (el) { el.textContent = moneyTrim(v.price); });
    $$('[data-aaa-quarter]').forEach(function (el) { el.textContent = formatMoney(Math.floor(v.price / 4)); });
    var was = $('[data-aaa-was]'), save = $('[data-aaa-save]'), amt = $('[data-aaa-save-amt]');
    var on = v.compare > v.price;
    if (was) { was.hidden = !on; if (on) was.textContent = moneyTrim(v.compare); }
    if (save) { save.hidden = !on; if (on && amt) amt.textContent = moneyTrim(v.compare - v.price); }
    $$('[data-aaa-save-pill]').forEach(function (el) {
      el.hidden = !on;
      if (on) el.textContent = 'Save ' + moneyTrim(v.compare - v.price);
    });
    $$('[data-aaa-sku]').forEach(function (el) { el.textContent = v.sku || ''; });
    optSets.forEach(function (fs, oi) {
      var out = fs.querySelector('[data-aaa-opt-val]');
      if (out) out.textContent = v.options[oi];
    });
    if (fromUser) {
      if (v.media) showMedia(v.media);
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* ignore */ }
      document.dispatchEvent(new CustomEvent('variant:changed', { detail: { variant: v } }));
    }
    markAvailability();
  }
  optSets.forEach(function (fs) {
    fs.addEventListener('change', function () { applyVariant(findVariant(selectedOptions()), true); });
  });
  if (optSets.length) markAvailability();

  /* ---- Quantity -------------------------------------------------------- */
  var qtyInput = $('[data-aaa-qty-input]');
  $$('[data-aaa-qty]').forEach(function (b) {
    b.addEventListener('click', function () {
      var n = (parseInt(qtyInput.value, 10) || 1) + parseInt(b.getAttribute('data-aaa-qty'), 10);
      qtyInput.value = Math.max(1, n);
    });
  });
  if (qtyInput) qtyInput.addEventListener('change', function () { qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) || 1); });

  /* ---- Add to cart ----------------------------------------------------- */
  var added = addedEl;
  var addedTimer = null;
  var lastFocus = null;
  function showAdded(item) {
    if (!added) return;
    lastFocus = document.activeElement;
    var img = $('[data-aaa-added-img]', added);
    if (img) {
      if (item.image) { img.src = item.image; img.hidden = false; } else { img.hidden = true; }
    }
    $('[data-aaa-added-title]', added).textContent = item.title;
    $('[data-aaa-added-meta]', added).textContent = item.meta;
    added.hidden = false;
    var h = added.querySelector('[tabindex="-1"]');
    if (h) h.focus({ preventScroll: true });
    clearTimeout(addedTimer);
    addedTimer = setTimeout(hideAdded, 8000);
  }
  function hideAdded() {
    if (!added || added.hidden) return;
    added.hidden = true;
    clearTimeout(addedTimer);
    if (lastFocus && added.contains(document.activeElement)) { try { lastFocus.focus({ preventScroll: true }); } catch (e) { /* noop */ } }
  }
  if (added) {
    $('[data-aaa-added-close]', added).addEventListener('click', hideAdded);
    added.addEventListener('mouseenter', function () { clearTimeout(addedTimer); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hideAdded(); });
  }
  function cartAdd(body) {
    var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) { var err = new Error(j.description || j.message || 'Could not add to cart'); err.data = j; throw err; }
        return j;
      });
    });
  }
  function afterAdd() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  var atc = $('[data-aaa-atc]');
  var errEl = $('[data-aaa-error]');
  if (form && atc) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      e.stopPropagation();
      if (atc.disabled || atc.classList.contains('is-busy')) return;
      var v = currentVariant();
      var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      if (errEl) errEl.hidden = true;
      atc.classList.add('is-busy');
      atc.setAttribute('aria-busy', 'true');
      cartAdd({ items: [{ id: v ? v.id : idInput.value, quantity: qty }] })
        .then(function () {
          atc.classList.remove('is-busy');
          atc.classList.add('is-done');
          var lab = $('[data-aaa-atc-label]', atc);
          var prevText = lab.textContent;
          lab.textContent = 'Added';
          setTimeout(function () { atc.classList.remove('is-done'); lab.textContent = prevText; }, 2200);
          var title = data.productTitle + (v && v.title !== 'Default Title' ? ' — ' + v.title : '');
          showAdded({ title: title, image: (v && v.image) || data.image, meta: 'Qty ' + qty + ' · ' + formatMoney((v ? v.price : 0) * qty) });
          afterAdd();
        })
        .catch(function (err) {
          atc.classList.remove('is-busy');
          if (errEl) { errEl.textContent = err.message || 'Something went wrong. Please try again.'; errEl.hidden = false; }
        })
        .then(function () { atc.removeAttribute('aria-busy'); });
    }, true);
  }
  $$('[data-aaa-proxy-atc]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!form) return;
      if (optSets.length > 1 && !currentVariant()) { window.scrollTo({ top: 0, behavior: smooth }); return; }
      if (form.requestSubmit) { form.requestSubmit(atc); } else { atc.click(); }
    });
  });

  /* Quick add on rail cards (rails also render in other sections, so listen on document) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-aaa-quick-add]');
    if (!b) return;
    e.preventDefault();
    if (b.classList.contains('is-busy')) return;
    b.classList.add('is-busy');
    var label = b.querySelector('span');
    cartAdd({ items: [{ id: parseInt(b.getAttribute('data-aaa-quick-add'), 10), quantity: 1 }] })
      .then(function () {
        b.classList.add('is-done');
        if (label) label.textContent = 'Added';
        showAdded({ title: b.getAttribute('data-title'), image: b.getAttribute('data-img'), meta: 'Qty 1 · ' + b.getAttribute('data-price') });
        afterAdd();
        setTimeout(function () { b.classList.remove('is-done'); if (label) label.textContent = 'Add'; }, 2400);
      })
      .catch(function (err) { if (label) label.textContent = 'Unavailable'; console.warn(err); })
      .then(function () { b.classList.remove('is-busy'); });
  });

  /* ---- Sticky sub-nav, buy bar ----------------------------------------- */
  var subnav = $('[data-aaa-subnav]');

  var links = subnav ? $$('a[href^="#"]', subnav) : [];
  function setCurrentLink() {
    var y = (subnav ? subnav.getBoundingClientRect().bottom : 0) + Math.min(240, window.innerHeight * 0.25);
    var idx = -1;
    links.forEach(function (a, i) {
      if (a.parentElement && a.parentElement.hidden) return;
      var t = document.getElementById(a.getAttribute('href').slice(1));
      if (t && !t.hidden && t.getBoundingClientRect().top <= y) idx = i;
    });
    links.forEach(function (a, i) { a.classList.toggle('is-active', i === idx); });
  }
  links.forEach(function (a) {
    a.addEventListener('click', function (e) {
      var t = document.getElementById(a.getAttribute('href').slice(1));
      if (!t) return;
      e.preventDefault();
      var offset = (subnav ? subnav.offsetHeight : 0) + (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--aaa-header-h'), 10) || 0) - 1;
      window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - offset, behavior: smooth });
      if (history.replaceState) history.replaceState({}, '', a.getAttribute('href'));
    });
  });
  $$('.aaa-pdp-plate__more, [data-aaa-jump], [data-aaa-pair-compare], .aaa-pdp-assure a[href^="#"], .aaa-pdp-ship__warr a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var t = document.getElementById(a.getAttribute('href').slice(1));
      if (!t) return;
      e.preventDefault();
      if (a.hasAttribute('data-aaa-open-warranty')) {
        $$('details', t).some(function (d) {
          var sm = d.querySelector('summary');
          if (sm && /warranty/i.test(sm.textContent)) { d.open = true; return true; }
          return false;
        });
      }
      var offset = (subnav ? subnav.offsetHeight : 0) + (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--aaa-header-h'), 10) || 0) + 8;
      window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - offset, behavior: smooth });
    });
  });

  var buyZone = $('.aaa-pdp__actions');
  var ticking = false;
  function onScroll() {
    ticking = false;
    if (buyZone) {
      var br = buyZone.getBoundingClientRect();
      var past = br.bottom < 0;
      // Phone bar: only once the real Add to cart has scrolled up and away.
      // Never in the first view, so it can't sit over the price or double the CTA.
      var out = past;
      root.classList.toggle('is-past-buy', past);
      root.classList.toggle('is-bar-on', out);
      document.body.classList.toggle('aaa-pdp-bar-on', out);
      $$('[data-aaa-subnav-buy]').forEach(function (el) {
        el.setAttribute('aria-hidden', past ? 'false' : 'true');
        $$('button', el).forEach(function (b) { b.tabIndex = past ? 0 : -1; });
      });
      $$('[data-aaa-bar]').forEach(function (el) {
        el.setAttribute('aria-hidden', out ? 'false' : 'true');
        $$('button', el).forEach(function (b) { b.tabIndex = out ? 0 : -1; });
      });
    }
    chatSync();
    if (subnav) subnav.classList.toggle('is-stuck', subnav.getBoundingClientRect().top <= (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--aaa-header-h'), 10) || 0) + 1);
    setCurrentLink();
  }
  /* Video card: the title side plays it too (phones show a compact card). */
  $$('.aaa-pdp-vrow').forEach(function (row) {
    var txt = $('.aaa-pdp-vrow__txt', row);
    if (!txt) return;
    txt.addEventListener('click', function () {
      var f = row.querySelector('.product-video-facade');
      if (f && !f.querySelector('iframe')) f.click();
    });
  });

  /* Chat launcher: kept out of the way until the buy box has scrolled past, so
     it can never sit on the title, rating or price. It lives in Shopify Inbox's
     open shadow root, so a scoped rule goes in there; the host fade covers the
     moment before that rule lands. */
  var chatRt = null, chatTries = 0;
  function chatSync() {
    var body = document.body;
    if (!chatRt) {
      var host = document.querySelector('shopify-chat');
      var rt = host && host.shadowRoot && host.shadowRoot.querySelector('shopify-agent-runtime');
      if (rt && rt.shadowRoot) {
        if (!rt.shadowRoot.querySelector('style[data-aaa-pdp-chat]')) {
          var st = document.createElement('style');
          st.setAttribute('data-aaa-pdp-chat', '');
          st.textContent = ':host([data-aaa-pdp-hold]) .activator-nudge{opacity:0!important;visibility:hidden!important;pointer-events:none!important}';
          rt.shadowRoot.appendChild(st);
        }
        chatRt = rt;
      }
    }
    var hold = !root.classList.contains('is-past-buy');
    if (chatRt) {
      if (chatRt.shadowRoot.querySelector('.activator[aria-expanded="true"]')) hold = false;
      if (hold) chatRt.setAttribute('data-aaa-pdp-hold', ''); else chatRt.removeAttribute('data-aaa-pdp-hold');
    }
    body.classList.toggle('aaa-pdp-chat-hold', hold);
  }
  (function chatPoll() {
    chatSync();
    if (!chatRt && ++chatTries < 90) setTimeout(chatPoll, 700);
  })();

  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(onScroll); }
  }, { passive: true });
  window.addEventListener('resize', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(onScroll); }
  }, { passive: true });
  onScroll();

  /* ---- Description clamp ---------------------------------------------- */
  $$('[data-aaa-clamp]').forEach(function (c) {
    var body = $('[data-aaa-clamp-body]', c), btn = $('[data-aaa-clamp-toggle]', c);
    if (!body || !btn) return;
    if (body.scrollHeight > (parseInt(c.getAttribute('data-clamp-at'), 10) || 640)) {
      c.classList.add('is-clamped');
      btn.hidden = false;
      btn.addEventListener('click', function () {
        var open = c.classList.toggle('is-clamped') === false;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? 'Show less' : 'Read the full rundown';
        if (!open) c.scrollIntoView({ behavior: smooth, block: 'start' });
      });
    }
  });

  /* Spec sheet: on phones, show the first rows and let them open the rest.
     The clamp is on a plain block wrapper (not the multi-column grid), so the
     hidden rows can't spill into an off-screen column and leave a hole. */
  /* (Phone spec sheet: see specPhone() below, after the warranty group is folded in.) */

  /* Our take on phones: the first point and the honest trade-off stay open; the middle opens on request. */
  $$('.aaa-pdp-takecard .aaa-pdp-take__facts').forEach(function (dl) {
    if (window.innerWidth >= 990 || dl.children.length < 4) return;
    dl.classList.add('is-short');
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'aaa-pdp-take__more';
    b.setAttribute('aria-expanded', 'false');
    var hiddenNames = $$(':scope > div:not(:first-child):not(:last-child) dt', dl).map(function (d) { return d.textContent.trim().toLowerCase(); });
    var more = hiddenNames.length ? 'More from our take: ' + hiddenNames.join(' and ') : 'Read the rest of our take';
    b.textContent = more;
    b.addEventListener('click', function () {
      var open = dl.classList.toggle('is-short') === false;
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      b.textContent = open ? 'Show less' : more;
    });
    dl.parentNode.insertBefore(b, dl.nextSibling);
  });

  /* ---- Rails ----------------------------------------------------------- */
  function initRails(scope) {
    $$('[data-aaa-rail]', scope).forEach(function (rail) {
      if (rail.dataset.aaaRailReady) return;
      rail.dataset.aaaRailReady = '1';
      var t = $('[data-aaa-rail-track]', rail), p = $('[data-aaa-rail-prev]', rail), n = $('[data-aaa-rail-next]', rail);
      if (!t) return;
      var cnt = $('[data-aaa-rail-count]', rail), prog = $('[data-aaa-rail-prog]', rail);
      function upd() {
        if (p) p.disabled = t.scrollLeft <= 4;
        if (n) n.disabled = t.scrollLeft >= t.scrollWidth - t.clientWidth - 4;
        var kids = Array.prototype.filter.call(t.children, function (k) { return k.offsetWidth > 0; }), total = kids.length;
        if (cnt && total) {
          // Which cards are fully in view: "1–4 of 7".
          var tl = t.getBoundingClientRect().left, tr = tl + t.clientWidth, first = 0, last = 0;
          for (var i = 0; i < total; i++) {
            var r = kids[i].getBoundingClientRect();
            if (r.left >= tl - 2 && r.right <= tr + 2) { if (!first) first = i + 1; last = i + 1; }
          }
          if (!first) { first = 1; last = 1; }
          cnt.textContent = (first === last ? first : first + '–' + last) + ' of ' + total;
        }
        if (prog) {
          // Thumb sized to the visible share; moved with transform only.
          var ratio = Math.min(1, t.clientWidth / Math.max(1, t.scrollWidth));
          var max = t.scrollWidth - t.clientWidth;
          var at = max > 0 ? t.scrollLeft / max : 0;
          prog.style.width = (ratio * 100) + '%';
          prog.style.transform = 'translateX(' + (at * (1 / ratio - 1) * 100) + '%)';
          prog.parentNode.hidden = ratio >= 0.999;
        }
      }
      function step(dir) { t.scrollBy({ left: dir * t.clientWidth * 0.8, behavior: smooth }); }
      if (p) p.addEventListener('click', function () { step(-1); });
      if (n) n.addEventListener('click', function () { step(1); });
      t.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd, { passive: true });
      upd();
    });
  }
  initRails(document);
  document.addEventListener('aaa:rails', function (e) { initRails(e.target && e.target.querySelectorAll ? e.target : document); });
  /* ---- Page order: pull the template's comparison + reviews into place ----
     Templates (incl. brand alternates we don't edit) put these sections after
     the product section. Move them into their slots so the page reads
     Overview > Features > Compare > Specs > Reviews > Accessories > Guides > Delivery. */
  function reveal(sel) { var el = $(sel); if (el) el.hidden = false; }
  var cmpSlot = $('[data-aaa-slot="compare"]');
  var cmpSec = document.querySelector('.shopify-section.product-comparison-section');
  if (cmpSlot && cmpSec && cmpSec.querySelector('.aaa-cmp')) {
    cmpSlot.appendChild(cmpSec);
    cmpSlot.hidden = false;
    reveal('[data-aaa-subnav-compare]');
    reveal('[data-aaa-pair-compare]');
    root.classList.add('has-compare');
  }
  if (!root.classList.contains('has-compare')) $$('[data-aaa-feat-cmp]').forEach(function (a) { a.parentNode.removeChild(a); });

  /* ---- Reviews: house header, junk filtered, photo reviews first ------- */
  var revSec = $('[data-aaa-rev]');
  // The buy-box rating waits for the review list to be read; never longer than this.
  setTimeout(function () { var r = $('[data-aaa-rating].is-pending'); if (r) r.classList.remove('is-pending'); }, 3000);
  var revMount = revSec && $('[data-aaa-rev-mount]', revSec);
  var spRev = document.getElementById('sp-reviews');
  if (revSec && revMount && spRev) {
    var spSection = spRev.closest('.shopify-section');
    revMount.appendChild(spRev);
    if (spSection) spSection.classList.add('aaa-pdp-moved');
    revSec.hidden = false;
    reveal('[data-aaa-subnav-reviews]');
    var busy = false;
    var tidy = function () {
      if (busy) return;
      busy = true;
      var list = spRev.querySelector('.sp-reviews__list');
      if (list) {
        var items = Array.prototype.slice.call(list.querySelectorAll('.sp-reviews__item'));
        var dist = [0, 0, 0, 0, 0], rated = 0;
        items.forEach(function (it) {
          var r = it.querySelector('.sp-reviews__rating');
          var m = r && /([1-5])\s*out of/.exec(r.getAttribute('aria-label') || '');
          if (m) { dist[parseInt(m[1], 10) - 1]++; rated++; }
          var body = it.querySelector('.sp-reviews__content');
          var txt = body ? body.textContent.replace(/[\s.\-_,!?*]+/g, '') : '';
          var hasPhoto = !!it.querySelector('.sp-reviews__photo, .sp-reviews__photos img');
          it.classList.toggle('aaa-rev-empty', txt.length < 3 && !hasPhoto);
          it.classList.toggle('aaa-rev-photo', hasPhoto);
        });
        // Newest first, by the review's own date.
        var when = function (it) {
          var d = it.querySelector('.sp-reviews__date');
          var tms = d ? Date.parse(d.textContent.trim()) : NaN;
          return isNaN(tms) ? 0 : tms;
        };
        // Product reviews lead (photo ones first); reviews that only talk about
        // buying from us are labelled "Store review" and sit after them.
        // A cooker review has to say something about cooking on it. Generic praise
        // ("great BBQ", "quality product") beside a word about buying from us is a
        // store review: it rates the purchase, not the cooker.
        var PROD = /\b(?:kamado|cook\w*|smok\w*|sear\w*|pizza|brisket|ribs|steak|wings|heat|temp\w*|ceramic|charcoal|lump|vent|lid|dome|grates?|versatile|durable|easy to use|joe|series|low[ -]and[ -]slow)\b/i;
        var STORE = /\b(?:oz ?bbq|deal(?:t)? with|guys|team|staff|service|deliver\w*|shipp\w*|arrived|dispatch\w*|responsive|purchas\w*|customer|order(?:ed)?)\b/i;
        var kind = function (it) {
          var b = it.querySelector('.sp-reviews__content');
          var t = b ? b.textContent : '';
          var p = PROD.test(t.replace(/oz ?bbq/ig, '')), st = STORE.test(t);
          return (st && !p) ? 'store' : 'product';
        };
        items.forEach(function (it) {
          var k = kind(it);
          it.classList.toggle('aaa-rev-store', k === 'store');
          var head = it.querySelector('.sp-reviews__item-header');
          var tag = it.querySelector('.aaa-rev-tag');
          if (k === 'store' && head && !tag) {
            tag = document.createElement('span');
            tag.className = 'aaa-rev-tag';
            tag.textContent = 'About our service';
            head.appendChild(tag);
          } else if (k !== 'store' && tag) { tag.parentNode.removeChild(tag); }
        });
        var rank = function (it) {
          if (it.classList.contains('aaa-rev-empty')) return 3;
          if (it.classList.contains('aaa-rev-store')) return 2;
          return 0;
        };
        var sorted = items.slice().sort(function (a, b) { return (rank(a) - rank(b)) || (when(b) - when(a)); });
        var inOrder = sorted.every(function (it, i) { return items[i] === it; });
        if (!inOrder) sorted.forEach(function (it) { list.appendChild(it); });
        // Service reviews get their own labelled group, so they never read as cooker ratings.
        var firstStore = null, anyProd = false;
        sorted.forEach(function (it) {
          if (it.classList.contains('aaa-rev-empty')) return;
          if (it.classList.contains('aaa-rev-store')) { if (!firstStore) firstStore = it; } else anyProd = true;
        });
        var grp = list.querySelector('.aaa-rev-grouph');
        if (firstStore && anyProd) {
          if (!grp) {
            grp = document.createElement('div');
            grp.className = 'aaa-rev-grouph';
            grp.setAttribute('role', 'heading');
            grp.setAttribute('aria-level', '3');
            grp.innerHTML = '<strong>About buying from us</strong><span>These rate Oz BBQ&rsquo;s service, not the cooker.</span>';
          }
          if (firstStore.previousElementSibling !== grp) list.insertBefore(grp, firstStore);
        } else if (grp) { grp.parentNode.removeChild(grp); }
        // Photos: load now (no lazy hole), and gather them as owner photos in the summary.
        var pics = [];
        sorted.forEach(function (it) {
          Array.prototype.forEach.call(it.querySelectorAll('img.sp-reviews__photo'), function (im) {
            im.loading = 'eager';
            pics.push(im);
          });
        });
        var picsBox = $('[data-aaa-rev-pics]', revSec), picsRow = $('[data-aaa-rev-picsrow]', revSec);
        if (picsBox && picsRow && pics.length >= 3 && !picsRow.childElementCount) {
          pics.slice(0, 6).forEach(function (im, n) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'aaa-pdp-rev__pic';
            b.setAttribute('aria-label', 'Open owner photo ' + (n + 1) + ' of ' + pics.length);
            var c = document.createElement('img');
            c.src = im.currentSrc || im.src; c.alt = ''; c.width = 88; c.height = 88; c.decoding = 'async';
            b.appendChild(c);
            b.addEventListener('click', function () { im.click(); });
            picsRow.appendChild(b);
          });
          picsBox.hidden = false;
        }
        // Verification, said once and plainly.
        var verEl = $('[data-aaa-rev-ver]', revSec);
        var shown = items.filter(function (it) { return !it.classList.contains('aaa-rev-empty'); });
        var nVer = shown.filter(function (it) { return !!it.querySelector('.sp-reviews__verified'); }).length;
        shown.forEach(function (it) { it.classList.toggle('aaa-rev-unver', !it.querySelector('.sp-reviews__verified')); });
        if (verEl && shown.length) {
          // One sentence that reconciles every number on the block.
          // Service-only reviews stay on the list, marked; the line says so plainly.
          var totalR = parseInt(revSec.getAttribute('data-count'), 10) || items.length;
          var nStore = shown.filter(function (it) { return it.classList.contains('aaa-rev-store'); }).length;
          var nProd = shown.length - nStore;
          nVer = shown.filter(function (it) { return !it.classList.contains('aaa-rev-store') && !!it.querySelector('.sp-reviews__verified'); }).length;
          // Nothing is hidden except star-only ratings (no words to show), and the
          // sentence says exactly that, so every number on the block adds up.
          // Reviews about buying from us aren't shown on a product page (they rate the
          // shop, not the cooker), so the sentence counts cooker reviews only.
          var nWritten = nProd, nBare = Math.max(0, totalR - shown.length);
          var line = nWritten ? nWritten + (nWritten === 1 ? ' written review' : ' written reviews') : '';
          if (nWritten && nBare) line += ' and ' + nBare + ' star-only ' + (nBare === 1 ? 'rating' : 'ratings');
          line += line ? ', shown unedited.' : '';
          if (nStore) line += ' ' + (nStore === 1 ? 'One review was about our service rather than the cooker, so it isn’t shown here.' : nStore + ' reviews were about our service rather than the cooker, so they aren’t shown here.');
          if (nVer) line += ' A tick means a verified Oz BBQ buyer.';
          if (!nProd) {
            // Nothing about the cooker yet: no chapter of service reviews in its place.
            revSec.classList.add('aaa-rev-noprod');
            revSec.hidden = true;
            var snLi = $('[data-aaa-subnav-reviews]'); if (snLi) snLi.hidden = true;
          }
          // The headline count, broken down: what's about the cooker, what's about us.
          var splitEl = $('[data-aaa-rev-split]', revSec);
          if (splitEl && (nStore || nBare)) {
            var bits = [];
            bits.push('<strong class="aaa-num">' + nProd + '</strong> ' + (nProd === 1 ? 'is' : 'are') + ' about the cooker');
            if (nStore) bits.push('<strong class="aaa-num">' + nStore + '</strong> about our service');
            if (nBare) bits.push('<strong class="aaa-num">' + nBare + '</strong> left stars only');
            var last = bits.pop();
            splitEl.innerHTML = 'Of those, ' + (bits.length ? bits.join(', ') + ' and ' : '') + last + '.';
            splitEl.hidden = false;
          }
          // Buy box and sub-nav: count what owners said about the cooker, not every rating.
          var pSum = 0, pN = 0;
          shown.forEach(function (it) {
            if (it.classList.contains('aaa-rev-store')) return;
            var r = it.querySelector('.sp-reviews__rating');
            var m = r && /([1-5])\s*out of/.exec(r.getAttribute('aria-label') || '');
            if (m) { pSum += parseInt(m[1], 10); pN++; }
          });
          var rate = $('[data-aaa-rating]');
          if (!rate) {
            var snN0 = $('[data-aaa-subnav-reviews] .aaa-pdp-subnav__n');
            if (snN0) { if (nProd >= 3) snN0.textContent = nProd; else snN0.parentNode.removeChild(snN0); }
          }
          if (totalR < 10) {
            // The bar chart counts every rating; beside an owner-only headline it would muddle it.
            var dEl = $('[data-aaa-rev-dist]', revSec);
            if (dEl && (nStore || nBare)) revSec.classList.add('aaa-rev-split-on');
            var snN = $('[data-aaa-subnav-reviews] .aaa-pdp-subnav__n');
            if (rate && nProd >= 3) {
              var pAvg = pN ? pSum / pN : 0;
              var rc = $('[data-aaa-rating-count]', rate), rs = $('[data-aaa-rating-stars]', rate), rv = $('[data-aaa-rating-vh]', rate);
              if (rc) rc.textContent = nProd + (nProd === 1 ? ' owner review' : ' owner reviews');
              if (rs && pN) rs.style.setProperty('--pct', Math.round(pAvg * 20) + '%');
              if (rv) rv.textContent = (pN ? 'Rated ' + pAvg.toFixed(1) + ' out of 5 by ' : 'Reviewed by ') + nProd + (nProd === 1 ? ' owner' : ' owners') + '. Jump to reviews.';
              rate.classList.remove('is-pending');
              if (snN) snN.textContent = nProd;
            } else if (rate) {
              // Under three owner reviews, stars under the title oversell; the
              // reviews chapter says what there is.
              rate.parentNode.removeChild(rate);
              // A count of one or two on the tab advertises how thin it is; the tab just says Reviews.
              if (snN) snN.parentNode.removeChild(snN);
            }
            var early = $('.aaa-pdp-rev__early > span:last-child', revSec);
            if (early && nProd > 0 && pN) {
              early.innerHTML = '<strong class="aaa-num">' + (pSum / pN).toFixed(1) + '</strong> from ' + nProd + (nProd === 1 ? ' owner review' : ' owner reviews');
              var es = $('.aaa-pdp-rev__early .aaa-pdp__stars', revSec);
              if (es) es.style.setProperty('--pct', Math.round(pSum / pN * 20) + '%');
            }
            if (splitEl) {
              // Said once, in the "how these reviews work" note; not as a second line here.
              splitEl.hidden = true;
            }
          }
          // One quiet "how these work" note (hover, focus or tap), not admin text in the rail.
          var rngEl = $('[data-aaa-rev-range]', revSec);
          var tipId = 'AaaRevTip-' + (root.getAttribute('data-section-id') || '0');
          if (!verEl.querySelector('.aaa-pdp-rev__how')) {
            verEl.innerHTML = '<button type="button" class="aaa-pdp-rev__how" aria-expanded="false" aria-controls="' + tipId + '"><span class="aaa-pdp-rev__vinfo" aria-hidden="true"></span>How these reviews work</button>' +
              '<span class="aaa-pdp-rev__tip" id="' + tipId + '" role="note"></span>';
            var howBtn = verEl.querySelector('.aaa-pdp-rev__how');
            howBtn.addEventListener('click', function () {
              var on = verEl.classList.toggle('is-open');
              howBtn.setAttribute('aria-expanded', on ? 'true' : 'false');
            });
            verEl.addEventListener('keydown', function (e) { if (e.key === 'Escape' && verEl.classList.contains('is-open')) { verEl.classList.remove('is-open'); howBtn.setAttribute('aria-expanded', 'false'); howBtn.focus(); } });
            document.addEventListener('click', function (e) { if (!verEl.contains(e.target) && verEl.classList.contains('is-open')) { verEl.classList.remove('is-open'); howBtn.setAttribute('aria-expanded', 'false'); } });
          }
          /* One or two owner reviews: no ratings widget (a 5.0 from one review reads
             thin). The owner's own photo and words lead as a testimonial, and the
             brand's other cookers' ratings, from the same review app, sit beside it
             as plainly labelled range proof. */
          var testi = nProd > 0 && nProd < 3;
          revSec.classList.toggle('aaa-rev-testi', testi);
          if (testi) {
            var rh = $('.aaa-pdp-ch__title', revSec);
            if (rh) rh.textContent = nProd === 1 ? 'From an owner' : 'From owners';
            if (rngEl) { rngEl.hidden = false; rngEl.classList.add('is-lead'); }
          }
          verEl.querySelector('.aaa-pdp-rev__tip').innerHTML = '<span>' + line + '</span>' + (rngEl && !testi ? '<span>' + rngEl.innerHTML + '</span>' : '');
          verEl.hidden = false;
        }
        // Star distribution only when every rating is on the page (no guessing).
        var distEl = $('[data-aaa-rev-dist]', revSec);
        var total = parseInt(revSec.getAttribute('data-count'), 10) || 0;
        // A star-only rating isn't on the page, but when the average pins it down
        // (all 5s, or exactly one missing rating) it can still be counted honestly.
        var avg = parseFloat(revSec.getAttribute('data-avg')) || 0, miss = total - rated;
        if (miss > 0 && avg > 0 && rated > 0) {
          var sum = 0; for (var q = 0; q < 5; q++) sum += dist[q] * (q + 1);
          var whole = Math.round(avg * 10) / 10;
          if (whole === 5 || whole === 1) { dist[whole - 1] += miss; rated += miss; }
          else if (miss === 1) {
            var left = avg * total - sum, lv = Math.round(left);
            if (lv >= 1 && lv <= 5 && Math.abs(left - lv) < 0.06) { dist[lv - 1]++; rated++; }
          }
        }
        if (distEl && rated > 0 && rated === total && total >= 3) {
          var html = '';
          for (var st = 5; st >= 1; st--) {
            var n = dist[st - 1], pct = Math.round(n / rated * 100);
            html += '<li><span class="aaa-pdp-rev__lab">' + st + ' star</span><span class="aaa-pdp-rev__bar" aria-hidden="true"><span style="width:' + pct + '%"></span></span><span class="aaa-pdp-rev__n aaa-num">' + n + '<span class="aaa-vh"> ' + (n === 1 ? 'rating' : 'ratings') + '</span></span></li>';
          }
          distEl.innerHTML = html;
          distEl.setAttribute('aria-label', 'Ratings by star');
          distEl.hidden = false;
        }
      }
      var w = spRev.querySelector('.sp-reviews__write'), mine = $('[data-aaa-rev-write]', revSec);
      if (w && mine && mine.hidden) {
        var nOwn = $$('.sp-reviews__item', spRev).filter(function (it) { return !it.classList.contains('aaa-rev-store') && !it.classList.contains('aaa-rev-empty'); }).length;
        mine.textContent = 'Own one? Write a review';
        mine.hidden = false;
        mine.addEventListener('click', function () {
          w.click();
          var f = spRev.querySelector('.sp-reviews__form');
          mine.setAttribute('aria-expanded', f && !f.hidden ? 'true' : 'false');
          if (f && !f.hidden) { var first = f.querySelector('select, input, textarea'); if (first) first.focus(); }
        });
      }
      setTimeout(function () { busy = false; }, 0);
    };
    tidy();
    if (window.MutationObserver) new MutationObserver(tidy).observe(spRev, { childList: true, subtree: true });
  }

  /* ---- Accessories: fold a template's "Featured Products" picks into the rail --- */
  var fpSec = document.querySelector('.shopify-section.product-scroll-section');
  var gear = document.getElementById('AaaGear-' + root.getAttribute('data-section-id'));
  if (fpSec) fpSec.classList.add('aaa-pdp-moved');
  if (fpSec && gear && window.fetch) {
    var have = {};
    $$('.aaa-pdp-rail__item a[href*="/products/"]', gear).forEach(function (a) {
      var h = a.getAttribute('href').split('/products/')[1];
      if (h) have[decodeURIComponent(h.split('?')[0])] = 1;
    });
    if (window.product && window.product.handle) have[window.product.handle] = 1;
    // Already offered in the starter kit above: not again in the gear rail.
    $$('[data-aaa-bun] a[href*="/products/"]').forEach(function (a) {
      var h = a.getAttribute('href').split('/products/')[1];
      if (h) have[decodeURIComponent(h.split('?')[0])] = 1;
    });
    var handles = [];
    Array.prototype.forEach.call(fpSec.querySelectorAll('.product-card a[href*="/products/"]'), function (a) {
      var h = decodeURIComponent(a.getAttribute('href').split('/products/')[1].split('?')[0]);
      if (h && !have[h]) { have[h] = 1; handles.push(h); }
    });
    var gearTrack = $('[data-aaa-rail-track]', gear);
    var loadGear = function () {
      var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      Promise.all(handles.slice(0, 8).map(function (h) {
        return fetch(rootUrl + 'products/' + encodeURIComponent(h) + '?section_id=aaa-pdp-card-api', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .catch(function () { return ''; });
      })).then(function (htmls) {
        var added = 0;
        // The same product listed twice under two handles ("...Classic Joe" and
        // "...Classic Joe®") shows once.
        var norm = function (el) { var t = el && el.querySelector('.aaa-pdp-card__title, .aaa-pdp-card__name, h3, [class*="title"]'); return t ? t.textContent.toLowerCase().replace(/[^a-z0-9]+/g, '') : ''; };
        var seenT = {};
        $$('.aaa-pdp-rail__item', gearTrack).forEach(function (li) { var k = norm(li); if (k) seenT[k] = 1; });
        htmls.forEach(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var li = tmp.querySelector('.aaa-pdp-rail__item');
          var tk = li ? norm(li) : '';
          if (li && tk && seenT[tk]) li = null;
          if (li) {
            if (tk) seenT[tk] = 1;
            $$('img[loading="lazy"]', li).forEach(function (im) { im.loading = 'eager'; });
            gearTrack.appendChild(li); added++;
          }
        });
        if (added) {
          $$('.aaa-pdp-rail__item.is-soldout', gearTrack).forEach(function (li) { gearTrack.appendChild(li); });
          gear.hidden = false;
          reveal('[data-aaa-subnav-gear]');
          delete gear.dataset.aaaRailReady;
          initRails(gear.parentNode);
        }
      });
    };
    if (handles.length && gearTrack) {
      if ('IntersectionObserver' in window && !gear.hidden) {
        var gio = new IntersectionObserver(function (es) {
          if (es.some(function (e) { return e.isIntersecting; })) { gio.disconnect(); loadGear(); }
        }, { rootMargin: '1200px 0px' });
        gio.observe(gear);
      } else { loadGear(); }
    }
  }

  /* ---- Starter bundle ---------------------------------------------------- */
  $$('[data-aaa-bun]').forEach(function (bun) {
    var boxes = $$('[data-aaa-bun-item]', bun);
    var totalEl = $('[data-aaa-bun-total]', bun), wasEl = $('[data-aaa-bun-was]', bun);
    var labEl = $('[data-aaa-bun-label]', bun), fineEl = $('[data-aaa-bun-fine]', bun);
    var btn = $('[data-aaa-bun-add]', bun), btnLab = $('[data-aaa-bun-btn]', bun);
    var bundlePrice = parseInt(bun.getAttribute('data-bundle-price'), 10) || 0;
    var bundleOk = bun.getAttribute('data-bundle-available') === 'true';
    var fineAll = fineEl ? (fineEl.getAttribute('data-fine-all') || fineEl.textContent) : '';
    /* Desktop has the room: the kit is laid out, not folded behind a toggle. */
    var bunSum = bun.querySelector('summary');
    // Open on every screen: on phones the names, prices and one Add-all button are the offer.
    var bunWide = window.matchMedia('(min-width: 0px)');
    function bunMode() {
      var wide = bunWide.matches;
      bun.classList.toggle('is-static', wide);
      if (wide) bun.open = true;
      if (bunSum) { if (wide) bunSum.setAttribute('tabindex', '-1'); else bunSum.removeAttribute('tabindex'); }
    }
    if (bunSum) bunSum.addEventListener('click', function (e) { if (bun.classList.contains('is-static')) e.preventDefault(); });
    if (bunWide.addEventListener) bunWide.addEventListener('change', bunMode);
    bunMode();
    function bunState() {
      var on = boxes.filter(function (b) { return b.checked && !b.disabled; });
      var all = on.length === boxes.length && bundleOk;
      var cur = currentVariant();
      var sum = cur ? cur.price : 0;
      on.forEach(function (b) { sum += parseInt(b.getAttribute('data-price'), 10) || 0; });
      return { on: on, all: all, sum: sum, count: on.length + 1 };
    }
    function paint() {
      var st = bunState();
      if (st.all) {
        labEl.textContent = 'Kit price';
        totalEl.textContent = formatMoney(bundlePrice);
        if (wasEl) wasEl.hidden = false;
        fineEl.textContent = fineAll;
      } else if (st.on.length) {
        labEl.textContent = 'Total for ' + st.count + ' items';
        totalEl.textContent = formatMoney(st.sum);
        if (wasEl) wasEl.hidden = true;
        fineEl.textContent = bundleOk ? 'Tick every extra for the kit price. These go in at their own prices.' : 'Each extra goes in at its own price.';
      } else {
        labEl.textContent = 'Nothing extra ticked';
        totalEl.textContent = formatMoney(st.sum);
        if (wasEl) wasEl.hidden = true;
        fineEl.textContent = bundleOk ? 'All optional. Tick what you want added with it; tick all ' + boxes.length + ' for the kit price.' : 'All optional. Tick what you want added with it.';
      }
      /* Opt-in: with nothing ticked the button sits back, disabled, and never
         competes with the main Add to cart. */
      var none = !st.on.length;
      if (btn) { btn.disabled = none; btn.classList.toggle('is-idle', none); btn.setAttribute('aria-disabled', none ? 'true' : 'false'); }
      btnLab.textContent = none ? 'Tick the extras you want' : (st.all ? 'Add all ' + st.count + ' to cart' : 'Add these ' + st.count + ' to cart');
      $$('.aaa-pdp-bun__item', bun).forEach(function (li) {
        var b = li.querySelector('[data-aaa-bun-item]');
        li.classList.toggle('is-off', !!b && !b.checked);
      });
    }
    boxes.forEach(function (b) { b.addEventListener('change', paint); });
    document.addEventListener('variant:changed', paint);
    paint();
    if (btn) btn.addEventListener('click', function () {
      if (btn.disabled || btn.classList.contains('is-busy')) return;
      var st = bunState();
      var items;
      if (st.all) {
        items = [{ id: parseInt(bun.getAttribute('data-bundle-variant'), 10), quantity: 1, properties: { _bundle: 'yes' } }];
      } else {
        var cur = currentVariant();
        items = [{ id: cur ? cur.id : parseInt(idInput.value, 10), quantity: 1 }];
        st.on.forEach(function (b) { items.push({ id: parseInt(b.getAttribute('data-aaa-bun-item'), 10), quantity: 1 }); });
      }
      btn.classList.add('is-busy');
      var prev = btnLab.textContent;
      btnLab.textContent = 'Adding…';
      cartAdd({ items: items }).then(function () {
        btnLab.textContent = 'Added';
        showAdded({ title: st.all ? 'Starter bundle (' + st.count + ' items)' : st.count + ' items', image: data.image, meta: formatMoney(st.all ? bundlePrice : st.sum) });
        afterAdd();
        setTimeout(function () { btnLab.textContent = prev; }, 2400);
      }).catch(function (err) {
        btnLab.textContent = prev;
        if (fineEl) fineEl.textContent = err.message || 'Could not add the bundle. Try again or call us.';
      }).then(function () { btn.classList.remove('is-busy'); });
    });
  });

  /* ---- Delivery estimate -------------------------------------------------
     Stock state comes from Ship Planner (same feed as the old stock widget).
     The estimate uses the store's published times: VIC & NSW 2-4 business
     days, everywhere else 5-7 (the transit time in our structured data).
     Business days only, and it's labelled an estimate. */
  var ship = $('[data-aaa-ship]');
  if (ship) {
    var shipText = $('[data-aaa-ship-text]', ship), etaBox = $('[data-aaa-ship-eta]', ship);
    var shipLine = $('[data-aaa-ship-line]', ship), sform = $('[data-aaa-ship-form]', ship);
    var pcIn = $('[data-aaa-ship-pc]', ship), shipFine = $('[data-aaa-ship-fine]', ship);
    var defaultLine = shipLine ? shipLine.innerHTML : '';
    var stateOf = function (pc) {
      if (!/^\d{4}$/.test(pc)) return null;
      var n = parseInt(pc, 10);
      if ((n >= 2600 && n <= 2618) || (n >= 2900 && n <= 2920)) return 'ACT';
      if (n >= 2000 && n <= 2999) return 'NSW';
      if ((n >= 3000 && n <= 3999) || (n >= 8000 && n <= 8999)) return 'VIC';
      if (n >= 4000 && n <= 4999) return 'QLD';
      if (n >= 5000 && n <= 5999) return 'SA';
      if (n >= 6000 && n <= 6999) return 'WA';
      if (n >= 7000 && n <= 7999) return 'TAS';
      if (n >= 800 && n <= 999) return 'NT';
      return null;
    };
    var addBiz = function (d, n) {
      var x = new Date(d.getTime());
      while (n > 0) { x.setDate(x.getDate() + 1); var wd = x.getDay(); if (wd !== 0 && wd !== 6) n--; }
      return x;
    };
    var fmtDay = function (d) { return d.toLocaleDateString('en-AU', { weekday: 'short', day: 'numeric', month: 'short' }); };
    var showEta = function (pc) {
      var stt = stateOf(pc);
      if (!stt) { if (shipFine) { shipFine.textContent = 'Pop in a 4-digit Australian postcode.'; shipFine.hidden = false; } return; }
      var near = stt === 'VIC' || stt === 'NSW';
      var lo = near ? 2 : 5, hi = near ? 4 : 7;
      var now = new Date();
      if (quoteBox) quoteBox.hidden = true;
      shipLine.innerHTML = 'Est. delivery to <button type="button" class="aaa-pdp-ship__pc aaa-num" data-aaa-ship-change aria-label="Change postcode, currently ' + pc + '">' + pc + '</button> <strong>' + fmtDay(addBiz(now, lo)) + ' &ndash; ' + fmtDay(addBiz(now, hi)) + '</strong>';
      sform.hidden = true;
      if (shipFine) { shipFine.textContent = (near ? 'VIC & NSW' : stt) + ' orders typically arrive ' + lo + '–' + hi + ' business days after you order. Freight is priced to your postcode at checkout.'; shipFine.hidden = false; }
      var ch = $('[data-aaa-ship-change]', ship);
      if (ch) ch.addEventListener('click', function () {
        shipLine.innerHTML = defaultLine; sform.hidden = false; if (shipFine) shipFine.hidden = true; pcIn.focus();
      });
      try { localStorage.setItem('aaa_pc', pc); } catch (e) { /* ignore */ }
    };
    /* One postcode, both answers: freight cost, delivery window and the ways to get it,
       from Ship Planner's rate API (the one its own calculator used). If that's
       unavailable, fall back to the published delivery times. */
    var quoteBox = $('[data-aaa-ship-quote]', ship), goBtn = $('[data-aaa-ship-go]', ship);
    var moneyAud = function (cents) { return cents === 0 ? 'Free' : '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
    var dayOf = function (str) {
      var m = str ? /^(\d{4})-(\d{2})-(\d{2})/.exec(str) : null;
      return m ? new Date(+m[1], +m[2] - 1, +m[3]) : null;
    };
    var esc = function (t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; };
    var goLabel = goBtn ? goBtn.innerHTML : '';
    var quote = function (pc) {
      if (!quoteBox || !window.fetch || !stateOf(pc)) { showEta(pc); return; }
      var qty = Math.max(1, parseInt((qtyInput && qtyInput.value) || '1', 10) || 1);
      if (goBtn) { goBtn.disabled = true; goBtn.setAttribute('aria-busy', 'true'); goBtn.textContent = 'Checking\u2026'; }
      var done = function () { if (goBtn) { goBtn.disabled = false; goBtn.removeAttribute('aria-busy'); goBtn.innerHTML = goLabel; } };
      var ctl = window.AbortController ? new AbortController() : null;
      var timer = setTimeout(function () { if (ctl) ctl.abort(); }, 9000);
      fetch(ship.getAttribute('data-api') + '/shipping_rate_extension', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ product_handles: [ship.getAttribute('data-handle')], quantities: [qty], destination: { postal_code: pc }, shop: ship.getAttribute('data-shop') }),
        signal: ctl ? ctl.signal : undefined
      }).then(function (r) { return r.json(); }).then(function (d) {
        clearTimeout(timer); done();
        if (!d || d.error || typeof d.estimated_cost !== 'number') { showEta(pc); return; }
        var lo = dayOf(d.min_delivery_date), hi = dayOf(d.max_delivery_date);
        var when = lo && hi ? (lo.getTime() === hi.getTime() ? fmtDay(lo) : fmtDay(lo) + ' &ndash; ' + fmtDay(hi)) : '';
        shipLine.innerHTML = 'Delivered to <button type="button" class="aaa-pdp-ship__pc aaa-num" data-aaa-ship-change aria-label="Change postcode, currently ' + pc + '">' + pc + '</button>' + (when ? ' <strong>' + when + '</strong>' : '');
        sform.hidden = true;
        var rows = [{ name: 'Home delivery', note: when ? 'Arrives ' + when : 'Delivery date confirmed at dispatch', price: d.free_shipping ? 0 : d.estimated_cost, lead: true }];
        if (d.depot_collect && typeof d.depot_collect.estimated_cost === 'number') {
          var dp = d.depot_collect.depot || {};
          rows.push({ name: 'Collect from ' + esc(dp.name || 'the freight depot'), note: esc([dp.suburb, dp.state].filter(Boolean).join(' ')), price: d.depot_collect.estimated_cost });
        }
        if (d.in_warehouse_stock) rows.push({ name: 'Click &amp; Collect, Eaglehawk', note: 'From our warehouse near Bendigo. We call when it&rsquo;s ready.', price: 0 });
        var html = '<ul class="aaa-pdp-ship__opts" role="list">';
        rows.forEach(function (r) {
          html += '<li class="aaa-pdp-ship__opt' + (r.lead ? ' is-lead' : '') + '"><span class="aaa-pdp-ship__optn"><strong>' + r.name + '</strong>' + (r.note ? '<span>' + r.note + '</span>' : '') + '</span><span class="aaa-pdp-ship__optp aaa-num">' + moneyAud(r.price) + '</span></li>';
        });
        quoteBox.innerHTML = html + '</ul>';
        quoteBox.hidden = false;
        if (shipFine) {
          shipFine.innerHTML = (d.origin && d.origin.text ? esc(d.origin.text) + '. ' : '') + 'Priced for ' + qty + ' &times; this item. Freight is confirmed at checkout.';
          shipFine.hidden = false;
        }
        var ch = $('[data-aaa-ship-change]', ship);
        if (ch) ch.addEventListener('click', function () {
          shipLine.innerHTML = defaultLine; sform.hidden = false; quoteBox.hidden = true; if (shipFine) shipFine.hidden = true; pcIn.focus();
        });
        try { localStorage.setItem('aaa_pc', pc); } catch (e) { /* ignore */ }
      }).catch(function () { clearTimeout(timer); done(); showEta(pc); });
    };
    if (sform) sform.addEventListener('submit', function (e) { e.preventDefault(); quote((pcIn.value || '').trim()); });
    if (pcIn) pcIn.addEventListener('input', function () { pcIn.value = pcIn.value.replace(/\D/g, '').slice(0, 4); if (shipFine) shipFine.hidden = true; });
    var savedPc = null;
    try { savedPc = localStorage.getItem('aaa_pc'); } catch (e) { savedPc = null; }

    var renderStock = function (st, d) {
      // Never contradict the buy button: if this variant can't be bought, the Liquid sold-out line stands.
      var cv = currentVariant();
      if (cv && !cv.available && !cv.backorder) { if (etaBox) etaBox.hidden = true; return; }
      ship.setAttribute('data-state', st);
      var msg = null;
      if (st === 'warehouse') msg = '<strong>In stock.</strong> Packed and sent from our own warehouse, or Click &amp; Collect free.';
      else if (st === 'dropship') msg = '<strong>Available.</strong> Ships direct from our supplier to your door.';
      else if (st === 'crossdock') msg = '<strong>Available.</strong> Comes through our Eaglehawk warehouse, so allow a little extra time.';
      else if (st === 'on_order') {
        var eta = null;
        try { eta = d && d.eta ? new Date(d.eta).toLocaleDateString('en-AU', { day: 'numeric', month: 'long' }) : null; } catch (e) { eta = null; }
        msg = '<strong>On order.</strong> ' + (eta ? 'Expected at our warehouse ' + eta + '. We dispatch as soon as it lands.' : 'We dispatch as soon as stock lands.');
      }
      if (msg && shipText) shipText.innerHTML = msg;
      if (etaBox) etaBox.hidden = st !== 'warehouse';
      if (st === 'warehouse' && savedPc && sform && !sform.hidden) quote(savedPc);
    };
    if (ship.getAttribute('data-state') === 'warehouse' && savedPc) quote(savedPc);
    var fetchStock = function (sku) {
      if (!sku || !window.fetch) return;
      var key = 'sp_ss_' + sku, cached = null;
      try { var raw = localStorage.getItem(key); if (raw) { var o = JSON.parse(raw); if (Date.now() - o.ts < 600000) cached = o.d; } } catch (e) { cached = null; }
      if (cached && cached.status && cached.status !== 'unknown') { renderStock(cached.status, cached); return; }
      fetch(ship.getAttribute('data-api') + '/api/inventory/public/stock-status?sku=' + encodeURIComponent(sku))
        .then(function (r) { return r.json(); })
        .then(function (d) {
          try { localStorage.setItem(key, JSON.stringify({ ts: Date.now(), d: d })); } catch (e) { /* ignore */ }
          if (d && d.status && d.status !== 'unknown') renderStock(d.status, d);
        })
        .catch(function () { /* keep the Liquid state */ });
    };
    fetchStock(ship.getAttribute('data-sku'));
    document.addEventListener('variant:changed', function (e) {
      var v = e.detail && e.detail.variant;
      if (v && v.sku) fetchStock(v.sku);
    });
  }


  /* ==== Round 4 ============================================================ */

  /* ---- Fit studio shots to their frame ------------------------------------
     Supplier cut-outs carry a lot of white margin, and every brand uses a
     different amount, so the same grill looks small in one frame and big in
     the next. Read a tiny copy of each image (the CDN allows CORS), find the
     product's bounding box against the background, then scale and centre it
     to fill a set share of the frame. Pure transform: no layout shift. */
  function applyFit(img) {
    var b = img._aaaBox; if (!b) return;
    var W = img.clientWidth, H = img.clientHeight;
    if (!W || !H) return;
    var cs = getComputedStyle(img);
    var pl = parseFloat(cs.paddingLeft) || 0, pr = parseFloat(cs.paddingRight) || 0, pt = parseFloat(cs.paddingTop) || 0, pb = parseFloat(cs.paddingBottom) || 0;
    var cw = W - pl - pr, ch = H - pt - pb;
    var rh = Math.min(cw / b.ar, ch), rw = rh * b.ar;   // object-fit: contain
    var ox = pl + (cw - rw) / 2, oy = pt + (ch - rh) / 2;
    var bx0 = ox + b.x0 * rw, bx1 = ox + b.x1 * rw, by0 = oy + b.y0 * rh, by1 = oy + b.y1 * rh;
    var k = Math.min(b.fw * W / (bx1 - bx0), b.fh * H / (by1 - by0), b.maxK);
    if (k < 1.02) k = 1;
    var tx = -k * ((bx0 + bx1) / 2 - W / 2), ty = -k * ((by0 + by1) / 2 - H / 2);
    img.style.setProperty('--ts', k.toFixed(4));
    img.style.setProperty('--tx', (tx / W * 100).toFixed(3) + '%');
    img.style.setProperty('--ty', (ty / H * 100).toFixed(3) + '%');
    img.classList.add('is-fit');
  }
  function fitImage(img, fw, fh, maxK) {
    if (!img || img.dataset.aaaFit) return;
    var src = img.currentSrc || img.src;
    if (!src || src.indexOf('data:') === 0) return;
    img.dataset.aaaFit = '1';
    var u;
    try { u = new URL(src, location.href); } catch (e) { return; }
    u.searchParams.set('width', '120');
    u.searchParams.delete('height');
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () {
      try {
        var w = probe.naturalWidth, h = probe.naturalHeight;
        if (!w || !h) return;
        var c = document.createElement('canvas'); c.width = w; c.height = h;
        var ctx = c.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(probe, 0, 0);
        var px = ctx.getImageData(0, 0, w, h).data;
        var bg = [0, 0, 0];
        [[1, 1], [w - 2, 1], [1, h - 2], [w - 2, h - 2]].forEach(function (p) {
          var i = (p[1] * w + p[0]) * 4;
          bg[0] += px[i] / 4; bg[1] += px[i + 1] / 4; bg[2] += px[i + 2] / 4;
        });
        // Light studio backgrounds only; photography is left alone.
        if (bg[0] < 225 || bg[1] < 225 || bg[2] < 225) return;
        var x0 = w, y0 = h, x1 = -1, y1 = -1;
        for (var y = 0; y < h; y++) {
          for (var x = 0; x < w; x++) {
            var i = (y * w + x) * 4;
            if (px[i + 3] < 24) continue;
            var d = Math.abs(px[i] - bg[0]) + Math.abs(px[i + 1] - bg[1]) + Math.abs(px[i + 2] - bg[2]);
            if (d > 42) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
          }
        }
        if (x1 < 0) return;
        img._aaaBox = { ar: w / h, x0: x0 / w, x1: (x1 + 1) / w, y0: y0 / h, y1: (y1 + 1) / h, fw: fw, fh: fh, maxK: maxK };
        applyFit(img);
      } catch (e) { /* unreadable: leave as is */ }
    };
    probe.src = u.toString();
  }
  function fitIn(scope) {
    $$('.aaa-pdp-gal__zoom.is-cutout .aaa-pdp-gal__img', scope).forEach(function (im) { fitImage(im, 0.86, 0.88, 1.7); });
    $$('.aaa-cmp__img:not(.is-dim):not(.is-diff) img', scope).forEach(function (im) { fitImage(im, 0.9, 0.84, 2.2); });
  }
  var galEl = $('[data-aaa-gal]');
  if (galEl) fitIn(galEl);
  $$('.aaa-pdp-bar__thumb, .aaa-pdp-subnav__thumb', document).forEach(function (im) { fitImage(im, 0.94, 0.94, 2); });
  if ('IntersectionObserver' in window) {
    var fitIO = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        fitIO.unobserve(e.target);
        fitIn(e.target.parentNode || e.target);
      });
    }, { rootMargin: '800px 0px' });
    $$('.aaa-cmp__img', document).forEach(function (el) { fitIO.observe(el); });
    /* Gear cards: every product drawn to the same share of its tile, so a
       rotisserie ring and a SloRoller read at the same scale. */
    var railFitIO = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        railFitIO.unobserve(e.target);
        $$('.aaa-card__media img', e.target).forEach(function (im) { fitImage(im, 0.8, 0.76, 2.6); });
      });
    }, { rootMargin: '600px 0px' });
    $$('.aaa-pdp-rail', document).forEach(function (el) { railFitIO.observe(el); });
  } else { fitIn(document); }
  var refitT = null;
  window.addEventListener('resize', function () {
    clearTimeout(refitT);
    refitT = setTimeout(function () { $$('img.is-fit', document).forEach(applyFit); }, 120);
  }, { passive: true });

  /* ---- Comparison: warranty folds into the spec sheet --------------------- */
  var cmpWarr = document.querySelector('template[data-aaa-cmp-warranty]');
  if (cmpWarr) {
    var specCols = $('[data-aaa-specclamp-body]');
    var frag = cmpWarr.content.cloneNode(true);
    if (specCols) {
      if (!specCols.querySelector('.aaa-pdp-specs__group--warranty')) specCols.appendChild(frag);
    } else if (cmpWarr.parentNode) {
      var hold = document.createElement('div');
      hold.className = 'aaa-cmp__warr';
      hold.appendChild(frag);
      cmpWarr.parentNode.insertBefore(hold, cmpWarr);
    }
  }

  /* ---- Spec sheet: fold a lone one-row group, then split into two even columns.
     CSS columns can't break a group, so one long group left a hole at the foot
     of the right column. Groups keep their order inside each column. */
  function balanceSpecs() {
    var body = $('[data-aaa-specclamp-body]');
    if (!body) return;
    if (!body.dataset.aaaFolded) {
      body.dataset.aaaFolded = '1';
      var gs0 = $$(':scope > .aaa-pdp-specs__group', body);
      var homeG = gs0.filter(function (g) { var h = $('.aaa-pdp-specs__gh', g); return h && /model|general|info/i.test(h.textContent); })[0] || gs0[0];
      var firstDl = homeG && $('.aaa-pdp-specs__dl', homeG);
      gs0.forEach(function (g) {
        if (g === homeG) return;
        var rows = $$('.aaa-pdp-specs__row', g), gh = $('.aaa-pdp-specs__gh', g);
        if (firstDl && rows.length === 1 && gh && /^(features?|other|general|extras?)$/i.test(gh.textContent.trim())) {
          firstDl.appendChild(rows[0]);
          g.parentNode.removeChild(g);
        }
      });
    }
    $$(':scope > .aaa-pdp-specs__col', body).forEach(function (c) {
      while (c.firstChild) body.insertBefore(c.firstChild, c);
      body.removeChild(c);
    });
    body.classList.remove('is-split');
    if (window.innerWidth < 900) return;
    var gs = $$(':scope > .aaa-pdp-specs__group', body);
    var n = gs.length;
    if (n < 2 || n > 12) return;
    var hs = gs.map(function (g) { return g.getBoundingClientRect().height; });
    var best = -1, bestD = Infinity;
    for (var m = 0; m < (1 << n); m += 2) { // group 0 always opens the left column
      var l = 0, r = 0;
      for (var k = 0; k < n; k++) { if (m & (1 << k)) r += hs[k]; else l += hs[k]; }
      if (!r) continue;
      var d = Math.abs(l - r) + (r > l ? 1 : 0);
      if (d < bestD) { bestD = d; best = m; }
    }
    if (best < 0) return;
    var cl = document.createElement('div'), cr = document.createElement('div');
    cl.className = cr.className = 'aaa-pdp-specs__col';
    gs.forEach(function (g, k) { (best & (1 << k) ? cr : cl).appendChild(g); });
    body.appendChild(cl); body.appendChild(cr);
    body.classList.add('is-split');
  }
  /* Size planning: if the maker publishes no depth, say so and offer to check, rather than leave a gap. */
  $$('[data-aaa-specclamp-body] .aaa-pdp-specs__group').forEach(function (g) {
    var h = $('.aaa-pdp-specs__gh', g);
    if (!h || !/physical|dimension/i.test(h.textContent)) return;
    var labels = $$('.aaa-pdp-specs__row dt', g).map(function (d) { return d.textContent.toLowerCase(); }).join('|');
    if (/depth|length/.test(labels) || g.querySelector('.aaa-pdp-specs__note')) return;
    var note = document.createElement('p');
    note.className = 'aaa-pdp-specs__note';
    var pub = ['width' + (/shelves/.test(labels) ? ' (shelves out)' : ''), 'height'];
    if (/weight/.test(labels)) pub.push('weight');
    var pubTxt = pub.length > 2 ? pub.slice(0, -1).join(', ') + ' and ' + pub[pub.length - 1] : pub.join(' and ');
    note.innerHTML = '<strong>Measuring up the deck?</strong> ' + (root.getAttribute('data-vendor') || 'The maker') + ' publishes ' + pubTxt + ' only. For depth and lid-open height, <a href="/pages/contact-us">ask a cook</a> and we&rsquo;ll put a tape on one in the Bendigo warehouse.';
    g.appendChild(note);
  });
  /* Spec groups in buyer order on every screen: cooking, size, temperatures, safety, model info last. */
  var specRank;
  (function specOrder() {
    var body = $('[data-aaa-specclamp-body]');
    if (!body) return;
    var gs = $$(':scope > .aaa-pdp-specs__group', body);
    var rank = specRank = function (g) {
      var h = $('.aaa-pdp-specs__gh', g), t = h ? h.textContent.toLowerCase() : '';
      if (/in the box/.test(t)) return 1.5;
      if (/temp/.test(t)) return 2;
      if (/cook/.test(t)) return 0;
      if (/physical|dimension|size/.test(t)) return 1;
      if (/operat|safety|fuel/.test(t)) return 4;
      if (/warrant/.test(t)) return 6;
      if (/model|general|info/.test(t)) return 8;
      return 5;
    };
    gs.map(function (g, i) { return { g: g, r: rank(g), i: i }; })
      .sort(function (x, y) { return x.r - y.r || x.i - y.i; })
      .forEach(function (o) { body.appendChild(o.g); });
  })();
  balanceSpecs();

  /* Spec sheet on phones: the numbers buyers came for first (cooking, then
     temperatures, then size), whole groups only. The rest folds behind one
     button that names what's behind it, so no heading sits half-faded. */
  /* Desktop too: cooking and size stay open, the rest (temperatures by style,
     safety, model info) folds behind the same named button, so the page isn't
     a wall of rows that repeat the key specs. */
  (function specPhone() {
    var c = $('[data-aaa-specclamp]');
    if (!c) return;
    var body = $('[data-aaa-specclamp-body]', c), btn = $('[data-aaa-specclamp-toggle]', c);
    if (!body || !btn) return;
    var gs = $$('.aaa-pdp-specs__group', body);
    if (gs.length < 3) return;
    // Desktop folds the same way: the numbers buyers came for stay open in two
    // balanced columns, temperatures by style, safety and model info sit behind
    // one named button, so the page reaches the reviews sooner.
    if (specRank) gs = gs.map(function (g, i) { return { g: g, r: specRank(g), i: i }; }).sort(function (x, y) { return x.r - y.r || x.i - y.i; }).map(function (o) { return o.g; });
    var keep = $('.aaa-pdp-specs__group--box', body) ? 3 : 2, hid = [];
    gs.forEach(function (g, i) {
      if (i < keep) return;
      g.classList.add('is-folded');
      var h = $('.aaa-pdp-specs__gh', g);
      if (!h) return;
      var t = h.textContent.trim().toLowerCase();
      hid.push(/temp/.test(t) ? 'temperatures' : /safety/.test(t) ? 'safety' : /model/.test(t) ? 'model info' : t.replace(/ specifications?$/, ''));
    });
    if (!hid.length) return;
    c.classList.remove('is-clamped');
    c.classList.add('is-folding');
    var win = $('[data-aaa-specclamp-win]', c); if (win) win.style.maxHeight = '';
    balanceSpecs(); // rebalance on what's open now, not on folded groups
    var label = 'Show the full spec sheet';
    btn.textContent = label;
    btn.hidden = false;
    btn.addEventListener('click', function () {
      var open = c.classList.toggle('is-folding') === false;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? 'Show fewer specs' : label;
      balanceSpecs();
      if (!open) c.scrollIntoView({ behavior: smooth, block: 'start' });
    });
  })();
  var specW = window.innerWidth, specT = null;
  window.addEventListener('resize', function () {
    if (Math.abs(window.innerWidth - specW) < 40) return;
    specW = window.innerWidth;
    clearTimeout(specT); specT = setTimeout(balanceSpecs, 150);
  }, { passive: true });

  /* ---- Sub-nav: height for sticky children, active tab kept in view -------- */
  if (subnav) {
    var setSubH = function () { document.documentElement.style.setProperty('--aaa-pdp-subnav-h', subnav.offsetHeight + 'px'); };
    setSubH();
    window.addEventListener('resize', setSubH, { passive: true });
    var linkList = $('.aaa-pdp-subnav__links', subnav);
    if (linkList) {
      var edge = function () {
        var max = linkList.scrollWidth - linkList.clientWidth;
        subnav.classList.toggle('has-more-r', max > 4 && linkList.scrollLeft < max - 4);
        subnav.classList.toggle('has-more-l', linkList.scrollLeft > 4);
      };
      linkList.addEventListener('scroll', edge, { passive: true });
      window.addEventListener('resize', edge, { passive: true });
      edge();
      setTimeout(edge, 1500);
      var lastActive = null, kivRaf = null;
      var keepInView = function () {
        kivRaf = null;
        var a = linkList.querySelector('a.is-active');
        if (!a || a === lastActive) return;
        lastActive = a;
        var li = a.parentElement;
        var l = li.offsetLeft - linkList.offsetLeft, r = l + li.offsetWidth;
        var vl = linkList.scrollLeft, vr = vl + linkList.clientWidth;
        if (l < vl + 16 || r > vr - 40) linkList.scrollTo({ left: Math.max(0, l - 24), behavior: smooth });
      };
      window.addEventListener('scroll', function () { if (!kivRaf) kivRaf = requestAnimationFrame(keepInView); }, { passive: true });
    }
  }

  /* ---- Buy bar steps aside over the footer -------------------------------- */
  var footEl = document.querySelector('footer.aaa-ftr') || document.querySelector('footer');
  if (footEl && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        root.classList.toggle('is-at-foot', e.isIntersecting);
        document.body.classList.toggle('aaa-pdp-bar-foot', e.isIntersecting);
      });
    }).observe(footEl);
  }

  /* ---- Image warm-up ----------------------------------------------------- */
  /* Native lazy-loading never fires for cards parked off to the side of a
     horizontal scroller (features, compare, gear, guides), so on phones they
     showed as empty boxes until swiped. Once the lead photo is in, fetch the
     page's own photos at low priority instead of waiting on window.load. */
  var warmed = false;
  var warm = function () {
    if (warmed) return;
    warmed = true;
    $$('img[loading="lazy"]', document).forEach(function (im) {
      if (!im.closest('.aaa-pdp, .aaa-cmp, #sp-reviews, .aaa-recs, .product-recommendations')) return;
      try { im.fetchPriority = 'low'; } catch (e) { /* older browsers */ }
      im.loading = 'eager';
    });
  };
  var lead = $('.aaa-pdp-gal__img', root);
  if (lead && !lead.complete) {
    lead.addEventListener('load', function () { setTimeout(warm, 150); }, { once: true });
    lead.addEventListener('error', warm, { once: true });
  } else {
    setTimeout(warm, 150);
  }
  setTimeout(warm, 1500);
  window.addEventListener('load', warm);
})();
